// Plugins
require('./dist/jquery.min')
// const scrollify = require('./plugins/_scrollify')
require('./plugins/_validator.min')
require('./plugins/_form-scripts')

// Custom
require('./_hamburger')
// const navigation = require('./_scrollifyNavigation')
require('./_logoAnimation')
require('./_showQANav')
require('./_viewPortDetect')
//require('./_work-page-nav.js')
require('./_svg-injector.js')
require('./_lazy-load')
require('./_analytics_events')
require('./_servicesSectionAnimation')
require('./_toggleNav')
require('./_scrollMagic')
require('./_smoothScroll')
 



// WEBPACK FOOTER //
// ./src/assets/js/main.js